export default (val: number): string => {
  let BYTES_PB = 10e14;
  let BYTES_TB_LIMIT = 9999995e8;
  let BYTES_TB = 10e11;
  let BYTES_GB_LIMIT = 9999995e5;
  let BYTES_GB = 10e8;
  let BYTES_MB_LIMIT = 9995e5;
  let BYTES_MB = 10e5;
  let BYTES_KB_LIMIT = 999500;
  let BYTES_KB = 1000;

  let formattedVal = '0 B';

  if (val >= BYTES_TB_LIMIT) {
    formattedVal = (val / BYTES_PB).toFixed(2) + ' PB';
  } else if (val >= BYTES_GB_LIMIT) {
    formattedVal = (val / BYTES_TB).toFixed(2) + ' TB';
  } else if (val >= BYTES_MB_LIMIT) {
    formattedVal = (val / BYTES_GB).toFixed(2) + ' GB';
  } else if (val >= BYTES_KB_LIMIT) {
    formattedVal = (val / BYTES_MB).toFixed(0) + ' MB';
  } else if (val >= BYTES_KB) {
    formattedVal = (val / BYTES_KB).toFixed(0) + ' KB';
  } else if (val) {
    formattedVal = val + ' B';
  }

  return formattedVal;
};
